import { useEffect, useState } from "react";
import { api, fmtTime } from "../../lib/api";
import { PageHeader, Loading, inputCls } from "../../components/common";

const Diff = ({ a }) => {
  if (!a.before && !a.after) return null;
  const b = a.before || {}, n = a.after || {};
  const keys = [...new Set([...Object.keys(b), ...Object.keys(n)])].filter((k) => JSON.stringify(b[k]) !== JSON.stringify(n[k]) && !["updated_at", "created_at"].includes(k));
  if (!keys.length) return null;
  return (
    <div className="mt-2 text-xs grid gap-1">
      {keys.slice(0, 12).map((k) => <div key={k} className="font-mono break-all"><b>{k}</b>: <span className="text-red-700 line-through">{JSON.stringify(b[k]) ?? "—"}</span> → <span className="text-green-800">{JSON.stringify(n[k]) ?? "—"}</span></div>)}
    </div>
  );
};

export default function Audit() {
  const [rows, setRows] = useState(null);
  const [q, setQ] = useState("");
  const [entity, setEntity] = useState("");
  useEffect(() => {
    const t = setTimeout(() => api.get("/audit", { params: { q: q || undefined, entity: entity || undefined, limit: 500 } }).then((r) => setRows(r.data)), 250);
    return () => clearTimeout(t);
  }, [q, entity]);
  return (
    <div>
      <PageHeader title="Audit History" sub="Every administrative and participant change: original entry, updated entry, responsible person, date/time and reason." />
      <div className="flex flex-wrap gap-2 mb-4">
        <input className={`${inputCls} h-10 max-w-xs`} placeholder="Search action, person or record ID" value={q} onChange={(e) => setQ(e.target.value)} data-testid="audit-search" />
        <select className={`${inputCls} h-10 w-auto`} value={entity} onChange={(e) => setEntity(e.target.value)} data-testid="audit-entity">
          <option value="">All records</option>{["meeting", "attendance", "participant", "gkks", "units", "ministries", "categories", "user", "monitor_assignment", "device", "conflict", "correction", "settings", "report"].map((x) => <option key={x}>{x}</option>)}
        </select>
      </div>
      {!rows ? <Loading /> : (
        <div className="grid gap-2" data-testid="audit-list">
          {rows.map((a) => (
            <details key={a.id} className="sfap-card px-4 py-3">
              <summary className="cursor-pointer flex flex-wrap justify-between gap-2 text-sm">
                <span><b>{a.action.replaceAll("_", " ")}</b> · {a.entity} <span className="font-mono text-xs text-stone-500">{String(a.entity_id).slice(0, 12)}</span></span>
                <span className="text-stone-600">{a.actor_name || "System"} ({a.actor_role}) · {fmtTime(a.at)}</span>
              </summary>
              {a.reason && <p className="text-sm mt-2">Reason: {a.reason}</p>}
              <Diff a={a} />
            </details>
          ))}
        </div>
      )}
    </div>
  );
}
